/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Fix separador de miles CLP: reemplaza coma por punto en window.theme.moneyFormat
document.addEventListener('DOMContentLoaded', function() {
  if (window.theme && window.theme.moneyFormat) {
    window.theme.moneyFormat = window.theme.moneyFormat.replace('amount', 'amount_no_decimals');
    window.theme.moneyWithCurrencyFormat = window.theme.moneyWithCurrencyFormat.replace('amount', 'amount_no_decimals');
  }
});

// Smart Nutrition — reduce el logo al activar el header sticky en escritorio
(function() {
  var scrollThreshold = 60;
  var compactLogoWidth = '215px';
  var desktopMedia = window.matchMedia('(min-width: 1000px)');

  function updateSmartStickyHeader() {
    var logo = document.querySelector('.shopify-section__header .header__logo-image');
    var headerInner = document.querySelector('.shopify-section__header .header__inner');

    if (!logo) return;

    logo.style.transition = 'max-width 0.25s ease';

    if (headerInner) {
      headerInner.style.transition = 'min-height 0.25s ease, padding 0.25s ease';
    }

    if (desktopMedia.matches && window.scrollY > scrollThreshold) {
      logo.style.setProperty('max-width', compactLogoWidth, 'important');

      if (headerInner) {
        headerInner.style.minHeight = '70px';
      }
    } else {
      logo.style.removeProperty('max-width');

      if (headerInner) {
        headerInner.style.removeProperty('min-height');
      }
    }
  }

  function initSmartStickyHeader() {
    updateSmartStickyHeader();
    window.addEventListener('scroll', updateSmartStickyHeader, { passive: true });
    window.addEventListener('resize', updateSmartStickyHeader, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmartStickyHeader);
  } else {
    initSmartStickyHeader();
  }
})();

